import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from 'amazon-cognito-identity-js';

function authenticate(username, password, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const userData = {
    Username: username,
    Pool: userPool
  };

  const authenticationData = {
    Username: username,
    Password: password,
  };

  Config.region = config.region;

  const cognitoUser = new CognitoUser(userData);
  const authenticationDetails = new AuthenticationDetails(authenticationData);

  const prom = new Promise((resolve, reject) => {
    localStorage.setItem('authenticated', false);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess(result) {
        const user = userPool.getCurrentUser();
        if (!user) {
          reject(new Error('User not found'));
        } else {
          user.getSession((err, session) => {
            if (err) {
              reject(err);
            } else if (!session.isValid()) {
              reject(new Error('Session is not valid'));
            } else {
              localStorage.setItem('authenticated', true);
              localStorage.setItem('jwtToken', session.idToken.jwtToken);
              // hardcoded for now
              localStorage.setItem('locationId', '');
              sessionStorage.setItem('product', '');

              AWS.config.region = config.region;
              const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
              cognitoidentityserviceprovider.getUser({ AccessToken: session.accessToken.jwtToken.toString() }, (error, getUserResult) => {
                if (error) {
                  reject(error);
                } else {
                  // create a proper object
                  const usr = {};
                  usr.username = getUserResult.Username;
                  for (let x = 0; x < getUserResult.UserAttributes.length; x += 1) {
                    const attribute = getUserResult.UserAttributes[x];
                    if (attribute.Name === 'custom:reportAuthorization') {
                      usr.reportAuthorization = attribute.Value;
                    } else if (attribute.Name === 'sub') {
                      usr.sub = attribute.Value;
                    } else if (attribute.Name === 'custom:accessAuthorization') {
                      usr.accessAuthorization = attribute.Value;
                    } else if (attribute.Name === 'custom:suffix') {
                      usr.suffix = attribute.Value;
                    } else if (attribute.Name === 'phone_number') {
                      usr.phone_number = attribute.Value;
                    } else if (attribute.Name === 'given_name') {
                      usr.given_name = attribute.Value;
                    } else if (attribute.Name === 'family_name') {
                      usr.family_name = attribute.Value;
                    } else if (attribute.Name === 'email') {
                      usr.email = attribute.Value;
                    }
                  }

                  resolve(usr);
                }
              });
            }
          });
        }
      },
      mfaSetup: (challengeName, challengeParameters) => {
        console.log('mfa setup');
      },
      associateSecretCode: (secretCode) => {
        console.log('associate secret code');
      },
      selectMFAType: (challengeName, challengeParameters) => {
        console.log('select mfa code');
      },
      totpRequired: (secretCode) => {
        console.log('Please input the TOTP code.');
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // TODO: add redirect to change pwd screen, remove hard coded values
        const error = {
          code: 'NEW_PASSWORD_REQUIRED',
          username,
          userAttributes,
          requiredAttributes,
          user: this,
          cognitoUser
        };
        reject(error);
      },
      onFailure(err) {
        const newErr = { ...err, username };
        if (err.code === 'PasswordResetRequiredException') {
          // we must send out a new token for the user to reset the password
          cognitoUser.forgotPassword({
            // we still reject to redirect to the correct page
            onSuccess: (resultForgot) => { reject(newErr); },
            onFailure: (errorForgot) => { reject(newErr); }
          });
        } else {
          console.log('fail auth');
          reject(newErr);
        }
      }
    });
  });

  return prom;
}

export default function login(username, password, config) {
  return dispatch => dispatch({
    type: 'LOGIN_FETCH',
    payload: authenticate(username, password, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/login.js